export default function({ state, commit, dispatch }, filterArgs) {
    commit('setFilterArgs', filterArgs)
    return filterArgs
}
